<template>
  <v-container fluid>
    <NavDrawer></NavDrawer>
    <AppBar></AppBar>
    <ProfileDialog v-if="profileDialog"></ProfileDialog>
    <router-view name="config"></router-view>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AppBar from "@/components/AppBar";
import NavDrawer from "@/components/NavDrawer";
import ProfileDialog from "@/components/config/user/Profile";

export default {
  data: () => ({}),
  computed: {
    ...mapGetters("app", ["profileDialog"]),
  },
  components: {
    AppBar,
    NavDrawer,
    ProfileDialog
  }
};
</script>